module.exports = __webpack_public_path__ + "img/icon57.4e7f439f.png";